import { render, staticRenderFns } from "./SettingsSelectorButton.vue?vue&type=template&id=9f052f24&scoped=true&"
import script from "./SettingsSelectorButton.vue?vue&type=script&lang=js&"
export * from "./SettingsSelectorButton.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSelectorButton.vue?vue&type=style&index=0&id=9f052f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f052f24",
  null
  
)

export default component.exports